<h3>{{ 'scheduler.general.add-selected' | translate }} {{ 'scheduler.resource-detail.skills.title' | translate }}</h3>
<mat-dialog-content>
  <div>To associate resources with skills, please use the Resource Admin page and add the skill to the relevant resource.</div>
  <div><br/></div>
  <button mat-flat-button color="primary" [routerLink]="['/setup/resources']" mat-dialog-close>Resource Admin</button>
</mat-dialog-content>
